import * as React from 'react';
import { useConfig } from '@websky/core/src/context';
import SearchFormPromoCode from '@websky/core/src/SearchForm/components/SearchForm/Bottom/PromoCode/PromoCode';
import PayByMiles from '@websky/core/src/SearchForm/components/SearchForm/Bottom/PayByMiles/PayByMiles';
import MultiCity from './MultiCity/MultiCity';
import OfferHotels from './OfferHotels/OfferHotels';
import css from './Bottom.css';
const Bottom = React.memo(props => {
    const { SearchForm: { enableComplexRoute, proMode, payByMiles, offerHotels } } = useConfig();
    return (React.createElement("div", { className: css.container },
        props.renderBefore,
        enableComplexRoute && !proMode && React.createElement(MultiCity, null),
        props.renderPromoCode ? props.renderPromoCode() : React.createElement(SearchFormPromoCode, null),
        payByMiles && React.createElement(PayByMiles, null),
        offerHotels && React.createElement(OfferHotels, null)));
});
export default Bottom;
